(() => {
  if (customElements.get('oilogic-quantity-input')) return;

/*
 * <oilogic-quantity-input> — stepper around a native number input.
 *
 * The input works on its own without JS; this element only wires the -/+
 * buttons and keeps the minus button disabled at the minimum. Dispatches
 * a native 'change' event so form logic sees stepped values.
 */
class OilogicQuantityInput extends HTMLElement {
  #ctrl = new AbortController();

  connectedCallback() {
    this.input = this.querySelector('input[type="number"]');
    if (!this.input) return;

    const { signal } = this.#ctrl;
    this.minusButton = this.querySelector('[data-quantity-minus]');
    this.plusButton = this.querySelector('[data-quantity-plus]');

    this.minusButton?.addEventListener('click', () => this.step(-1), { signal });
    this.plusButton?.addEventListener('click', () => this.step(1), { signal });
    this.input.addEventListener('change', () => this.clamp(), { signal });

    this.clamp();
  }

  disconnectedCallback() {
    this.#ctrl.abort();
  }

  get min() {
    return Number(this.input.min || 1);
  }

  step(delta) {
    const value = Number(this.input.value) || this.min;
    this.input.value = Math.max(this.min, value + delta);
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  clamp() {
    const value = Number(this.input.value);
    if (!Number.isFinite(value) || value < this.min) this.input.value = this.min;
    if (this.minusButton) this.minusButton.disabled = Number(this.input.value) <= this.min;
  }
}

customElements.define('oilogic-quantity-input', OilogicQuantityInput);
})();
